const build = `{
  "name": "stripe-terminal-sample-code",
  "version": "1.0.0",
  "description": "A sample Terminal implementation",
  "main": "server.js",
  "dependencies": {
    "express": "^4.17.1",
    "stripe": "^8.114.0"
  },
  "scripts": {
    "start": "node server.js"
  },
  "author": "stripe-samples",
  "license": "ISC"
}`;

export default {
  build,
};
